import { render, staticRenderFns } from "./redPocket.vue?vue&type=template&id=2014094a&scoped=true&"
import script from "./redPocket.vue?vue&type=script&lang=js&"
export * from "./redPocket.vue?vue&type=script&lang=js&"
import style0 from "./redPocket.vue?vue&type=style&index=0&id=2014094a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2014094a",
  null
  
)

export default component.exports